import { Queries } from '../../shared/utils/Queries';
import { IReferenceItem } from './reference.interface';
import { IRevision as IWorkflowRevision, IRevisionCheckpoint as IWorkflowRevisionCheckpoint } from '../../workflow-config/interfaces/revision.interface';
import { IWorkflowRequest } from '@ispm/workflow/interfaces/workflow-request.interface';
import { IWorkflowJobItem } from '@ispm/workflow/interfaces/job-item.interface';

// todo:remove those duplication from core, need to be only on workflow module

export type IWorkflowItem =  IWorkflowJobItem;

export type IRevision = IWorkflowRevision;

export type IWorkflow = IWorkflowRequest;

export type IRevisionCheckpoint = IWorkflowRevisionCheckpoint;

export enum WorkflowFeatures {
  REVISE_CHECKPOINTS = 'REVISE_CHECKPOINTS'
}

export class Workflow {
  public static COMPLETED_STEP_NAME = 'None';

  private static FEATURES = {
    [WorkflowFeatures.REVISE_CHECKPOINTS]: 2,
  };

  /**
   * comparing the current revision status with the statusesToCheck - string[]
   * @param {IRevision} revision
   * @param {string[]} statusesToCheck
   * @return {boolean}
   */
  public static checkCurrentStatus(revision: IRevision, statusesToCheck: string[]): boolean {
    return statusesToCheck.indexOf(revision.status.toLowerCase()) !== -1;
  }

  public static checkCurrentJob(workflow: IWorkflowRequest, jobToCheck: string[]): boolean {
    return jobToCheck.indexOf(workflow.activeJobName.toLowerCase()) !== -1;
  }

  /**
   * return the wanted input from the inputs array, this done by comparing the key
   * @param {IReferenceItem[]} inputs
   * @param {string} key
   * @param query
   * @return {IReferenceItem}
   */
  public static getInput(inputs: IReferenceItem[], key: string, query: any = null): IReferenceItem | null {
    return inputs ? inputs.find(input => Queries.findByProperty(input, 'key', key)) : null;
  }

  /**
   * get wanted reference from references array - this done by comparing the type
   * @param {IReferenceItem[]} references
   * @param {string} type
   * @param query
   * @return {IReferenceItem}
   */
  public static getReference(references: IReferenceItem[], type: string, query: any = null) {
    return references ? references.find(reference => Queries.findByProperty(reference, 'type', type)) : null;
  }

  /**
   * get practitioner reference from references array by practitioner type
   * @param {IReferenceItem[]} references
   * @param {string} practType
   * @return {string[]}
   */
  public static getReferencesByPractType(references: IReferenceItem[], practType: string): string[] {
    if (! references) {
      return null;
    }

    return references
      .filter(ref => Queries.findByProperty(ref, 'type', 'practitioner'))
      .map(ref => {
        const practitioner = JSON.parse(ref.value);

        return (practitioner.practType === practType) ? practitioner.practId : null;
      })
      .filter(id => (id != null));
  }

  /**
   * get the wanted revision - done by comparing ID
   * @param {IRevision[]} revisions
   * @param revisionId
   * @return {IRevision}
   */
  public static getRevision(revisions: IRevision[], revisionId) {
    return revisions ? revisions.find(revision => Queries.findByProperty(revision, 'id', revisionId)) : null;
  }

  /**
   * get the current step in the revision items
   *
   * @param {IRevision} revision
   * @param {String} jobId
   * @return {IWorkflowItem}
   */
  public static getStepByJobId(revision: IRevision, jobId: string): IWorkflowJobItem {
    return revision && jobId ? revision.items.find((item: IWorkflowItem) => Queries.findByProperty(item, 'id', jobId )) : null;

  }
  public static getCurrentStep(revision: IRevision, activeJobId: string): IWorkflowJobItem {
    return this.getStepByJobId(revision, activeJobId);
  }

  public static isFeatureAvailable(workflow, revisionId= workflow.activeRevision, feature: WorkflowFeatures) {
    const revision = Workflow.getRevision(workflow.revisions, revisionId);

    return (revision.resourceVersion && parseInt(revision.resourceVersion) >= this.FEATURES[feature]);
  }

}

